import React from 'react';
import { TabWrapper, TabWrapperSecondary } from '#app/components/InnerTabs/styles';
import InnerTab from '#app/components/InnerTabs/InnerTab';

/**
 * @param {'default'|'secondary'} [variant] — `secondary`: как default по отступам/типографике, на всю ширину строки и с переносом вкладок (портфели на РЕПО).
 */
const InnerTabs = ({ tabs, activeId, onClick, style, variant = 'default' }) => {
  const Wrap = variant === 'secondary' ? TabWrapperSecondary : TabWrapper;
  return (
    <Wrap style={style}>
      {tabs.map((tab) => (
        <InnerTab
          key={tab.id == null ? 'all' : tab.id}
          id={tab.id}
          variant={variant}
          title={typeof tab.title === 'string' ? tab.title : undefined}
          onClick={() => onClick(tab.id)}
          active={tab.id === activeId}
        >
          {tab.title}
        </InnerTab>
      ))}
    </Wrap>
  );
};

export default React.memo(InnerTabs);
